import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private UserData = new BehaviorSubject<any>('');
  private UserImage = new BehaviorSubject<any>('');
  currentUserData = this.UserData.asObservable();
  currentUserImage = this.UserImage.asObservable();
  //httpOptions: any;
  httpOptions = {
    headers: new HttpHeaders()
  };
  constructor(private http: HttpClient) {
    const accessToken = localStorage.getItem('accessToken');

    if (accessToken) {
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + accessToken,
          'No-Auth': 'True'
        })
      };
    }

  }

  GetAllHospital() {
    return this.http.get<any[]>(
      environment.API_Base_URL + 'HomeCare/GetAllHospital', this.httpOptions
    );
  }

  Get_Userprofile() {
    return this.http.get(`${environment.API_Base_URL}` + `Authentication/GetUserByname`)
  }
  update_profile(data: any) {
    return this.http.put(`${environment.API_Base_URL}` + `Authentication/UpdateUserProfile`, data)
  }
  changeUserImage(image: any) {

    this.UserImage.next(image)
  }
  Doctor_login(username: string) {
    return this.http.get(`${environment.API_Base_URL}` + `User/CheckUser_Role/${username}`)
  }
  Post_login(data: { username: string }) {
    const params = new HttpParams().set('username', data.username);
    return this.http.post(`${environment.API_Base_URL}Authentication/Login`, null, { params });
  }

  checkUserRole(mobile: string) {
    return this.http.get(
      `${environment.API_Base_URL}User/CheckUser_Role/${mobile}`
    );
  }

}
